import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { key: String }

  connect() {
    const stored = this.#read()
    if (stored === "collapsed") {
      this.element.classList.add("collapsed")
    }
    this.#updateAria()
  }

  toggle(event) {
    event.preventDefault()
    this.element.classList.toggle("collapsed")
    this.#write(this.element.classList.contains("collapsed") ? "collapsed" : "open")
    this.#updateAria()
  }

  #updateAria() {
    const toggle = this.element.querySelector(".gl-sidebar-section-title")
    if (toggle) {
      toggle.setAttribute("aria-expanded", !this.element.classList.contains("collapsed"))
    }
  }

  #storageKey() {
    return `sidebar-section-${this.keyValue}`
  }

  #read() {
    try { return localStorage.getItem(this.#storageKey()) } catch { return null }
  }

  #write(value) {
    try { localStorage.setItem(this.#storageKey(), value) } catch { /* noop */ }
  }
}
